// extracted by mini-css-extract-plugin
module.exports =  {"title-part-item":"_32bbee5fda--title-part-item--pWBYO"};